<template>
  <div>
    <div class="modal--content">
      <form @submit.prevent="onSubmit">
        <h3 class="subTitle">{{ $t('newFolder.subTitle') }}<span class="subTitle__star"> *</span></h3>
        <p4a-input
          v-model="folderName"
          class="folderName"
          :type="'text'"
          :size="'large'"
          :warning="{ visible: showFolderNameError,showIcon: true, message: $t('newFolder.errorMessage'), warningMessageOnBottom: true }"
          :valid="false"
          :fullWidth="true"
          :leftIcon="''"
          :placeholder="$t('newFolder.inputText')"
          :disabled="false"
          :autofocus="true"
        />
        <p4a-button
          :showIcon="false"
          :onlyIconVisible="false"
          :product="''"
          :size="'large'"
          :disable="false"
          :text="$t('newFolder.cancelButton')"
          @click="closeWindow"
        ></p4a-button>
        <p4a-button
          :disable="folderName === ''"
          class="acceptButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="'ds'"
          :size="'large'"
          :text="$t('newFolder.acceptButton')"
          @click="onSubmit"
        ></p4a-button>
      </form>
    </div>
  </div>
</template>

<script>
import * as treemenuApi from 'api/treemenuOldApi'
import mixins from 'mixins'

export default {
  name: 'newFolder',
  mixins: [mixins],
  data () {
    return {
      folderName: '',
      showFolderNameError: false
    }
  },
  methods: {
    onSubmit () {
      if (this.validate()) {
        const parentId = this.$route.params.id
        const data = {
          ParentId: parentId,
          Name: this.folderName
        }
        treemenuApi.addFolder(data).then(error => {
          if (error.ErrorCode === undefined) {
            this.reloadIframe('updateTreeView')
            window.close()
          } else {
            this.showFolderNameError = true
          }
        })
      } else {
        this.showFolderNameError = true
      }
    },
    closeWindow () {
      window.close()
    },
    // Checks folder input not empty
    checkNotEmpty () {
      return this.folderName !== ''
    },
    checkFolderNameChars () {
      let notAllowedCharacters = /\\|\/|:|\*|\?|"|<|<|>|\|/
      let result = !notAllowedCharacters.test(this.folderName)
      return result
    },
    checkNotTooLong () {
      return this.folderName.length <= 250
    },
    // Validates all checks
    validate () {
      return (
        this.checkNotEmpty() &&
        this.checkFolderNameChars() &&
        this.checkNotTooLong()
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.modal--content {
  padding: 16px 24px 24px 24px;

  .subTitle {
    font-size: 13px;
    margin-bottom: 7px;

    &__star {
      color: #00B8D2;
    }
  }
  .folderName {
    margin-bottom: 28px;
  }
  .acceptButton{
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/folder/newFolderOldApi.vue